import { Link } from 'react-router-dom';
import React from 'react'
import './Advone.css'

function Advone() {
    return (
        <div className="advone">
            <div className="advone_header">
                Up to 70% off | Electronics clearence store
            </div>
            <div className="advone_body">

                <img src=".\images\electronics.jpg" width="300px" />
            </div>
            <Link to ="./electronics">
            <div className="advone_footer" >
                
                See more
                
            </div>
            </Link>
        </div>
    )
}

export default Advone
